import {
  VISIT_LOCATION_OFFICE,
  VISIT_TYPE_PRESENTIAL,
  visitLocationOptions,
  visitTypeOptions,
} from '../constants/visitConstants';
import { useNavigate } from 'react-router-dom';
import {
  Alert,
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  Modal,
  Row,
} from 'reactstrap';
import Select from 'react-select';
import { Controller } from 'react-hook-form';
import TimelineHeader from '../../../components/headers/TimelineHeader';
import ProfileCard from '../../../components/ProfileCard';
import { useVisitCalendar } from '../../../hooks/useVisitCalendar';
import { useManagerInvestorVisitsCalendar } from '../hooks/useManagerInvestorVisitsCalendar';
import { VisitPreSaleState } from '../../../constants/visitsConstants';
import {
  formatStandarCalendarDate,
  getMinutesFromDate,
  getStringDate,
} from '../../../adapters/dateAdapter';
import {
  getVisitPreSaleStatusAdapter,
  getBadgeColorVisitPreSaleStatusAdapter,
} from '../adapters/visitsInvestorAdapter';
import OfficeAddressInfo from './OfficeAddressInfo';
import DeleteVisitModal from './DeleteVisitModal';

const InvestorProjectVisits = () => {
  const navigate = useNavigate();
  const {
    landlordEmail,
    setLandlordEmail,
    landlordFound,
    setLandlordFound,
    handleSearchLandlord,
    formError,
    setFormError,
    modalAdd,
    setModalAdd,
    isEdit,
    setIsEdit,
    modalView,
    setModalView,
    modalDoneCancelled,
    setModalDoneCancelled,
    deleteModalOpen,
    setDeleteModalOpen,
    closeAddEditModal,
    handleOpenDeleteModal,
    cancellationReasons,
    startDate,
    setStartDate,
    creationStartDate,
    hours,
    loadHours,
    fetchEvents,
    onSelect,
    onEventClick,
    onEventChange,
    event,
    control,
    setValue,
    watch,
    errors,
    officeAddress,
    projectAddress,
    doCreateVisit,
    doRescheduleVisit,
    handleDeleteVisit,
    handleCompleteVisit,
    propersOptions,
    sdrOptions,
  } = useManagerInvestorVisitsCalendar();

  const { calendarRef, changeCalendarView, addCalendarEvent } = useVisitCalendar({
    fetchEvents,
    onSelect,
    onEventClick,
    onEventChange,
  });

  return (
    <>
      <TimelineHeader name="Administrar Asesorías" parentName="Proyectos" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardHeader className="border-0">
                <Row className="align-items-center py-4">
                  <Col lg="6">
                    <h6 className="fullcalendar-title h2 text-white d-inline-block mb-0 mr-1">
                      {event?.currentDate}
                    </h6>
                  </Col>
                  <Col className="mt-3 mt-lg-0 text-lg-right" lg="6">
                    <Button
                      className="btn-neutral"
                      color="default"
                      onClick={() => changeCalendarView('dayGridMonth')}
                      size="sm"
                    >
                      Vista de mes
                    </Button>
                    <Button
                      className="btn-neutral"
                      color="default"
                      onClick={() => changeCalendarView('dayGridWeek')}
                      size="sm"
                    >
                      Vista 3 días
                    </Button>
                    <Button
                      className="btn-neutral"
                      color="default"
                      onClick={() => changeCalendarView('dayGridDay')}
                      size="sm"
                    >
                      Vista día
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <div
                  className="calendar"
                  data-toggle="calendar"
                  id="calendar"
                  ref={calendarRef}
                />
              </CardBody>
              <CardFooter />
            </Card>
          </div>
        </Row>
      </Container>

      {/* Modal add / reschedule */}
      <Modal
        isOpen={modalAdd}
        toggle={closeAddEditModal}
        className="modal-dialog-centered modal-secondary"
      >
        <div className="modal-header">
          <Row>
            <Col md="12">
              <Alert color="default">
                {isEdit
                  ? `Reagendar asesoría al ${formatStandarCalendarDate(event?.start, false)}`
                  : `Agendar asesoría el ${formatStandarCalendarDate(creationStartDate || '', false)}`}
              </Alert>
            </Col>
          </Row>
        </div>
        <form onSubmit={isEdit ? doRescheduleVisit : doCreateVisit(addCalendarEvent)}>
          <div className="modal-body">
            {!isEdit && (
              <FormGroup>
                <label className="form-control-label" htmlFor="plan_id">
                  Asignar Inversionista
                </label>
                <InputGroup className="mb-3">
                  <Input
                    onChange={({ target }) => setLandlordEmail(target.value || '')}
                    placeholder="Correo de inversionista"
                    type="text"
                  />
                  <InputGroupAddon addonType="append">
                    <Button onClick={handleSearchLandlord} color="primary" outline>
                      Buscar
                    </Button>
                  </InputGroupAddon>
                </InputGroup>
              </FormGroup>
            )}
            {landlordFound && (
              <Row>
                <Col md="12">
                  <h5>{isEdit ? 'Inversionista asignado' : 'Inversionista encontrado:'}</h5>
                  <ProfileCard
                    avatar={landlordFound.avatar}
                    name={landlordFound?.name}
                    phone={landlordFound?.phone}
                    showAvatar={true}
                  />
                </Col>
              </Row>
            )}
            {formError && (
              <Row>
                <Col md="12">
                  <Alert color="danger">{formError}</Alert>
                </Col>
              </Row>
            )}
            <FormGroup>
              <label className="form-control-label" htmlFor="start_time">
                Selecciona una hora
              </label>
              <Controller
                name="start_time"
                control={control}
                render={({ field: { ref } }) => (
                  <Select
                    key={`start_time-${hours.length}`}
                    placeholder="Selecciona una hora"
                    options={hours}
                    isOptionDisabled={(option: any) => option.disabled}
                    defaultValue={
                      isEdit
                        ? hours.find(
                            (opt: any) => opt.value === getMinutesFromDate(event?.start),
                          )
                        : undefined
                    }
                    onChange={(selected: any) => setValue('start_time', selected.value)}
                    ref={ref}
                  />
                )}
              />
              {errors.start_time?.message && (
                <Alert color="danger">{errors.start_time.message}</Alert>
              )}
            </FormGroup>
            {!isEdit && (
              <FormGroup>
                <label className="form-control-label" htmlFor="visit_type">
                  Tipo de asesoría
                </label>
                <Controller
                  name="visit_type"
                  control={control}
                  render={({ field: { value, ref } }) => (
                    <Select
                      placeholder="Selecciona el tipo"
                      options={visitTypeOptions}
                      value={
                        visitTypeOptions.find((opt) => opt.value === value) ||
                        visitTypeOptions[0]
                      }
                      onChange={(selected: any) => setValue('visit_type', selected.value)}
                      ref={ref}
                    />
                  )}
                />
              </FormGroup>
            )}
            {!isEdit && watch('visit_type') === VISIT_TYPE_PRESENTIAL && (
              <FormGroup>
                <label className="form-control-label" htmlFor="location">
                  Lugar de la asesoría
                </label>
                <Controller
                  name="location"
                  control={control}
                  render={({ field: { value, ref } }) => (
                    <Select
                      placeholder="Selecciona el lugar"
                      options={visitLocationOptions}
                      value={
                        visitLocationOptions.find((opt) => opt.value === value) ||
                        visitLocationOptions[0]
                      }
                      onChange={(selected: any) => setValue('location', selected.value)}
                      ref={ref}
                    />
                  )}
                />
                {(watch('location') ?? VISIT_LOCATION_OFFICE) === VISIT_LOCATION_OFFICE &&
                  officeAddress && (
                  <OfficeAddressInfo office={officeAddress} />
                )}
                {watch('location') === 'project' && projectAddress && (
                  <small className="text-muted d-block mt-2">
                    <i className="fa-solid fa-location-dot mr-1"></i>
                    {projectAddress}
                  </small>
                )}
              </FormGroup>
            )}
            <FormGroup>
              <h6 className="form-control-label">Seleccionar proper</h6>
              <Controller
                name="proper_id"
                control={control}
                render={({ field: { ref } }) => (
                  <Select
                    key={`proper_id-${propersOptions.length}`}
                    placeholder="Selecciona un proper"
                    options={propersOptions}
                    defaultValue={
                      isEdit
                        ? propersOptions.find(
                            (opt) => opt.value === event?.extendedProps.proper_id,
                          )
                        : undefined
                    }
                    onChange={(selected: any) => setValue('proper_id', selected.value)}
                    ref={ref}
                  />
                )}
              />
              {errors.proper_id?.message && (
                <Alert color="danger">{errors.proper_id.message}</Alert>
              )}
            </FormGroup>
            <Row>
              <Col lg="12" className="pb-2">
                <Button block onClick={closeAddEditModal} color="secondary" size="sm">
                  Cerrar
                </Button>
              </Col>
              <Col lg="12" className="pb-2">
                <Button
                  block
                  size="sm"
                  className="new-event--add"
                  color={isEdit ? 'default' : 'primary'}
                  type="submit"
                >
                  {isEdit ? 'Reagendar asesoría' : 'Crear asesoría'}
                </Button>
              </Col>
            </Row>
          </div>
        </form>
      </Modal>

      {/* Modal view active visit */}
      <Modal
        isOpen={modalView}
        toggle={() => setModalView(false)}
        className="modal-dialog-centered modal-secondary"
      >
        <div className="modal-body">
          <Form className="edit-event--form">
            <FormGroup>
              <Badge
                className="badge-lg"
                color={getBadgeColorVisitPreSaleStatusAdapter(event?.extendedProps.status)}
              >
                {getVisitPreSaleStatusAdapter(event?.extendedProps.status)}
              </Badge>
              <Alert className="mt-2" color="default">
                <div>Visita: {formatStandarCalendarDate(event?.start)}</div>
                {event?.extendedProps.proper_id && (
                  <div>
                    Proper asignado:{' '}
                    {propersOptions.find((p) => p.value === event.extendedProps.proper_id)?.label}
                  </div>
                )}
                {event?.extendedProps.sdr_id && (
                  <div>
                    SDR asignado:{' '}
                    {sdrOptions.find((s) => s.value === event.extendedProps.sdr_id)?.label ??
                      event.extendedProps.sdr_id}
                  </div>
                )}
              </Alert>
              <label className="form-control-label">Inversionista:</label>
              <ProfileCard
                avatar={event?.extendedProps.landlordInfo?.avatar || ''}
                name={
                  event?.extendedProps.landlordInfo?.name ||
                  event?.extendedProps.guestInfo?.name ||
                  ''
                }
                phone={
                  event?.extendedProps.landlordInfo?.phone ||
                  event?.extendedProps.guestInfo?.phone ||
                  ''
                }
                extraInfo={`${event?.title}`}
                showAvatar={true}
              />
            </FormGroup>
            <Row>
              <Col lg="12" className="pb-2">
                <Button block onClick={() => setModalView(false)} color="secondary" size="sm">
                  Cerrar
                </Button>
              </Col>
              {(!event?.extendedProps.landlordInfo &&
                event?.extendedProps.status === VisitPreSaleState.SCHEDULED) ||
                (event?.extendedProps.status === VisitPreSaleState.PENDING_APPROVAL && (
                  <Col lg="12" className="pb-2">
                    <Button
                      block
                      size="sm"
                      onClick={() => navigate(`/investors/guest/visits/${event.id}`)}
                      color="default"
                    >
                      Revisar asesoria
                    </Button>
                  </Col>
                ))}
              <Col lg="12" className="pb-2">
                <Button block onClick={handleOpenDeleteModal} color="danger" size="sm">
                  Eliminar asesoría
                </Button>
              </Col>
              {event?.extendedProps.landlordInfo && (
                <>
                  <Col lg="12" className="pb-2">
                    <Button
                      block
                      size="sm"
                      onClick={() =>
                        navigate(`/landlord/${event?.extendedProps.landlordInfo.id}/profile`)
                      }
                      color="default"
                    >
                      Ver perfil de inversionista
                    </Button>
                  </Col>
                  {[VisitPreSaleState.SCHEDULED, VisitPreSaleState.RESCHEDULED].includes(
                    event?.extendedProps.status,
                  ) && (
                    <>
                      <Col lg="12" className="pb-2">
                        <Button
                          block
                          onClick={() => {
                            setModalView(false);
                            setModalAdd(true);
                            setIsEdit(true);
                            setStartDate(event.startStr);
                            loadHours(getStringDate(event.start));
                            setLandlordFound({
                              avatar: event.extendedProps.landlordInfo.avatar,
                              name: event.extendedProps.landlordInfo.name,
                              phone: '',
                            });
                            setValue('proper_id', event.extendedProps.proper_id);
                            setValue('start_time', getMinutesFromDate(event.start));
                            setFormError('');
                          }}
                          color="info"
                          size="sm"
                        >
                          Editar asesoria
                        </Button>
                      </Col>
                      <Col lg="12" className="pb-2">
                        <Button
                          block
                          onClick={handleCompleteVisit}
                          color="success"
                          size="sm"
                        >
                          Completar asesoría
                        </Button>
                      </Col>
                    </>
                  )}
                </>
              )}
            </Row>
            <input className="edit-event--id" type="hidden" />
          </Form>
        </div>
      </Modal>

      {/* Modal view done or cancelled visit */}
      <Modal
        isOpen={modalDoneCancelled}
        toggle={() => setModalDoneCancelled(false)}
        className="modal-dialog-centered modal-secondary"
      >
        <div className="modal-body">
          <Form className="edit-event--form">
            <FormGroup>
              <Badge
                className="badge-lg"
                color={getBadgeColorVisitPreSaleStatusAdapter(event?.extendedProps.status)}
              >
                {getVisitPreSaleStatusAdapter(event?.extendedProps.status)}
              </Badge>
              <Alert className="mt-2" color="default">
                {`Fecha de visita: ${formatStandarCalendarDate(event?.start)}`}
              </Alert>
              <label className="form-control-label">Inversionista:</label>
              <ProfileCard
                avatar={event?.extendedProps.landlordInfo?.avatar || ''}
                name={
                  event?.extendedProps.landlordInfo?.name ||
                  event?.extendedProps.guestInfo?.name ||
                  ''
                }
                phone={
                  event?.extendedProps.landlordInfo?.phone ||
                  event?.extendedProps.guestInfo?.phone ||
                  ''
                }
                extraInfo={`${event?.title}`}
                showAvatar={true}
              />
            </FormGroup>
            <Row>
              <Col lg="12" className="pb-2">
                <Button
                  block
                  size="sm"
                  onClick={() => setModalDoneCancelled(false)}
                  color="secondary"
                >
                  Cerrar
                </Button>
              </Col>
              {event?.extendedProps.landlordInfo && (
                <Col lg="12" className="pb-2">
                  <Button
                    block
                    size="sm"
                    onClick={() =>
                      navigate(`/landlord/${event?.extendedProps.landlordInfo.id}/profile`)
                    }
                    color="default"
                  >
                    Ver perfil de inversionista
                  </Button>
                </Col>
              )}
            </Row>
            <input className="edit-event--id" type="hidden" />
          </Form>
        </div>
      </Modal>

      <DeleteVisitModal
        isOpen={deleteModalOpen}
        toggle={() => setDeleteModalOpen(false)}
        onConfirm={handleDeleteVisit}
        reasons={cancellationReasons}
      />
    </>
  );
};

export default InvestorProjectVisits;
